import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Navigation
      "chats": "Chats",
      "care_options": "Care Options",
      "profile": "Profile",
      
      // Care Grades
      "g0_name": "7-min Anonymous Chat",
      "g1_name": "15-min Anonymous Chat",
      "g2_name": "29-min Anonymous Chat",
      "g3_name": "15-min Anonymous Voice",
      "g4_name": "29-min Anonymous Voice",
      "g5_name": "30-min Therapy (Junior)",
      "g6_name": "45-min Therapy (Certified)",
      
      // Common
      "loading": "Loading...",
      "error": "Error",
      "success": "Success",
      "cancel": "Cancel",
      "confirm": "Confirm",
      "continue": "Continue",
      "back": "Back",
      
      // Auth
      "login": "Login",
      "register": "Register",
      "email": "Email",
      "password": "Password",
      "name": "Name",
      
      // Chat
      "type_message": "Type a message...",
      "send": "Send",
      "end_session": "End Session",
      "start_chat": "Start Chat",
      "start_call": "Start Call",
      "join_video": "Join Video Session",
      
      // Crisis
      "need_help": "Need urgent help?",
      "tele_manas": "Tele-MANAS Crisis Helpline",
      "call_now": "Call Now: 14416"
    }
  },
  hi: {
    translation: {
      // Navigation
      "chats": "चैट",
      "care_options": "देखभाल विकल्प",
      "profile": "प्रोफ़ाइल",
      
      // Care Grades
      "g0_name": "7-मिनट गुमनाम चैट",
      "g1_name": "15-मिनट गुमनाम चैट",
      "g2_name": "29-मिनट गुमनाम चैट",
      "g3_name": "15-मिनट गुमनाम वॉयस",
      "g4_name": "29-मिनट गुमनाम वॉयस",
      "g5_name": "30-मिनट थेरेपी (जूनियर)",
      "g6_name": "45-मिनट थेरेपी (प्रमाणित)",
      
      // Common
      "loading": "लोड हो रहा है...",
      "error": "त्रुटि",
      "success": "सफलता",
      "cancel": "रद्द करें",
      "confirm": "पुष्टि करें",
      "continue": "जारी रखें",
      "back": "वापस",
      
      // Auth
      "login": "लॉगिन",
      "register": "रजिस्टर",
      "email": "ईमेल",
      "password": "पासवर्ड",
      "name": "नाम",
      
      // Chat
      "type_message": "संदेश टाइप करें...",
      "send": "भेजें",
      "end_session": "सत्र समाप्त करें",
      "start_chat": "चैट शुरू करें",
      "start_call": "कॉल शुरू करें",
      "join_video": "वीडियो सत्र में शामिल हों",
      
      // Crisis
      "need_help": "तत्काल मदद चाहिए?",
      "tele_manas": "टेली-मानस संकट हेल्पलाइन",
      "call_now": "अभी कॉल करें: 14416"
    }
  },
  kn: {
    translation: {
      // Navigation
      "chats": "ಚಾಟ್‌ಗಳು",
      "care_options": "ಆರೈಕೆ ಆಯ್ಕೆಗಳು",
      "profile": "ಪ್ರೊಫೈಲ್",
      
      // Care Grades
      "g0_name": "7-ನಿಮಿಷ ಅನಾಮಧೇಯ ಚಾಟ್",
      "g1_name": "15-ನಿಮಿಷ ಅನಾಮಧೇಯ ಚಾಟ್",
      "g2_name": "29-ನಿಮಿಷ ಅನಾಮಧೇಯ ಚಾಟ್",
      "g3_name": "15-ನಿಮಿಷ ಅನಾಮಧೇಯ ವಾಯ್ಸ್",
      "g4_name": "29-ನಿಮಿಷ ಅನಾಮಧೇಯ ವಾಯ್ಸ್",
      "g5_name": "30-ನಿಮಿಷ ಥೆರಪಿ (ಜೂನಿಯರ್)",
      "g6_name": "45-ನಿಮಿಷ ಥೆರಪಿ (ಪ್ರಮಾಣಿತ)",
      
      // Common
      "loading": "ಲೋಡ್ ಆಗುತ್ತಿದೆ...",
      "error": "ದೋಷ",
      "success": "ಯಶಸ್ಸು",
      "cancel": "ರದ್ದುಮಾಡಿ",
      "confirm": "ದೃಢೀಕರಿಸಿ",
      "continue": "ಮುಂದುವರಿಸಿ",
      "back": "ಹಿಂದೆ",
      
      // Auth
      "login": "ಲಾಗಿನ್",
      "register": "ನೋಂದಣಿ",
      "email": "ಇಮೇಲ್",
      "password": "ಪಾಸ್‌ವರ್ಡ್",
      "name": "ಹೆಸರು",
      
      // Chat
      "type_message": "ಸಂದೇಶವನ್ನು ಟೈಪ್ ಮಾಡಿ...",
      "send": "ಕಳುಹಿಸಿ",
      "end_session": "ಸೆಷನ್ ಅಂತ್ಯಗೊಳಿಸಿ",
      "start_chat": "ಚಾಟ್ ಪ್ರಾರಂಭಿಸಿ",
      "start_call": "ಕರೆ ಪ್ರಾರಂಭಿಸಿ",
      "join_video": "ವೀಡಿಯೊ ಸೆಷನ್‌ಗೆ ಸೇರಿ",
      
      // Crisis
      "need_help": "ತುರ್ತು ಸಹಾಯ ಬೇಕೇ?",
      "tele_manas": "ಟೆಲಿ-ಮಾನಸ್ ಬಿಕ್ಕಟ್ಟು ಸಹಾಯವಾಣಿ",
      "call_now": "ಈಗ ಕರೆ ಮಾಡಿ: 14416"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;